import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import {
  format_date,
  GET,
  loading,
  profile,
  toFixed,
  total,
} from "../../components/CustomComponent.js";
import { report_outstanding_payments } from "../../components/Report.js";
import Pagination from "@mui/material/Pagination";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class OutstandingPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_month: "",
      count: 0,
      start_date: "",
      end_date: "",
      type: "",

      last_month: "",
      current_month: "",
      loading: false,

      data: [],
    };
  }

  // ★ หัวคอลัมน์ "เลขมาตร <เดือน>" เดิมคำนวณจากวันนี้เสมอ แม้กรองเดือนอื่นอยู่ → หัวคอลัมน์ไม่ตรงข้อมูล
  //   และ setMonth() บนวันที่ 29-31 ล้นไปเดือนถัดไป (เช่น 31 มี.ค. - 1 เดือน = 3 มี.ค.)
  //   ใช้เดือนที่กรอง (ถ้ามี) เป็นฐาน ออฟเซ็ต -1/-2 เท่าเดิม และสร้างวันที่เป็นวันที่ 1 ของเดือนเสมอ
  getMonthLabels = (filter_month) => {
    const [y, m] = (filter_month || "").split("-").map(Number);
    const base = y && m ? new Date(y, m - 1, 1) : new Date();
    const current = new Date(base.getFullYear(), base.getMonth() - 1, 1);
    const last = new Date(base.getFullYear(), base.getMonth() - 2, 1);
    return {
      last_month: format_date(last, "mmm"),
      current_month: format_date(current, "mmm"),
      date: current,
    };
  };

  async componentDidMount() {
    this.setState(this.getMonthLabels(""));
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_month } = this.state;
    loading(true);
    let body = {
      page: page,
      data_search: filter_search,
      month: filter_month ? filter_month.split("-")[1] : "",
      year: filter_month ? filter_month.split("-")[0] : "",
    };
    let result = await GET("api/admin/outstanding-payments/list", body);
    if (result?.status) {
      // ★ อัปเดตหัวคอลัมน์เดือนตามเดือนที่ใช้ค้นหาจริง (ไม่ใช่ค่าที่พิมพ์ค้างไว้ยังไม่กดค้นหา)
      this.setState(this.getMonthLabels(filter_month));
      let data = result.data;
      for (let item of data) {
        if (item.transaction_payments?.length > 0) {
          // s_add_debt
          // s_cable_cost
          // s_common_expenses
          // s_equipment_maintenance_fee
          // s_fire_cost
          // s_late_payment
          // s_meter_connect_cost
          // s_other_income
          // s_reduce_debt
          // s_waste_cost
          // s_water_bill
          if (item.transaction_payments.some((p) => p.s_water_bill)) {
            item.water_bill = 0;
          }
          if (item.transaction_payments.some((p) => p.s_waste_cost)) {
            item.waste_cost = 0;
          }
          if (item.transaction_payments.some((p) => p.s_reduce_debt)) {
            item.reduce_debt = 0;
          }

          if (item.transaction_payments.some((p) => p.s_other_income)) {
            item.other_income = 0;
          }
          if (item.transaction_payments.some((p) => p.s_meter_connect_cost)) {
            item.meter_connect_cost = 0;
          }
          if (item.transaction_payments.some((p) => p.s_late_payment)) {
            item.total_cost_late = 0;
          }
          if (item.transaction_payments.some((p) => p.s_fire_cost)) {
            item.fire_cost = 0;
          }
          if (
            item.transaction_payments.some((p) => p.s_equipment_maintenance_fee)
          ) {
            item.equipment_maintenance_fee = 0;
          }
          if (item.transaction_payments.some((p) => p.s_common_expenses)) {
            item.common_expenses = 0;
          }
          if (item.transaction_payments.some((p) => p.s_cable_cost)) {
            item.cable_cost = 0;
          }
          if (item.transaction_payments.some((p) => p.s_add_debt)) {
            item.add_debt = 0;
          }
          item.total_amount =
            item.water_bill +
            item.waste_cost +
            item.other_income +
            item.meter_connect_cost +
            item.total_cost_late +
            item.fire_cost +
            item.equipment_maintenance_fee +
            item.common_expenses +
            item.cable_cost +
            item.add_debt -
            item.reduce_debt;
        }
      }
      this.setState({ data, count: result.count }, () => {
          loading(false);
      });
    } else {
      loading(false);
    }
  };

  exportExcel = async (data) => {
    loading(true);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Summary");

    // ===== COLUMN =====
    ws.columns = [{ width: 5 }, { width: 30 }, { width: 15 }];

    let rowIndex = 1;

    // ===== SECTION HEADER =====
    const sectionHeader = () => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);
      row.values = [
        "บ้านเลขที่",
        "ชื่อ - สกุล",
        "จำนวนหน่วยที่ใช้",
        "ค่าน้ำประปา",
        "ค่าบริการอุปกรณ์",
        "ค่าส่วนกลาง",
        "ค่าขยะ",
        "ค่าเคเบิล",
        "รายรับอื่นๆ",
        "เพิ่ม/ลดหนี้",
        "ค่าเบี้ยประกัน",
        "ค่าต่อมิเตอร์",
        "ค่าปรับล่าช้า",
        "รวม",
      ];

      row.height = 25;
      row.alignment = { vertical: "middle" };

      // ใส่ style ทุก cell ในแถว
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF198754" },
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      });

      rowIndex++;
    };

    // ===== TABLE ROW =====
    const tableRow = ({
      address_number,
      full_name,
      unit_used,
      water_bill,
      equipment_maintenance_fee,
      common_expenses,
      waste_cost,
      cable_cost,
      other_income,
      add_debt,
      reduce_debt,
      fire_cost,
      meter_connect_cost,
      total_cost_late,
      total_amount,
    }) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);
      row.values = [
        address_number,
        full_name,
        unit_used,
        water_bill,
        equipment_maintenance_fee,
        common_expenses,
        waste_cost,
        cable_cost,
        other_income,
        add_debt - reduce_debt,
        fire_cost,
        meter_connect_cost,
        total_cost_late,
        water_bill +
          equipment_maintenance_fee +
          common_expenses +
          waste_cost +
          cable_cost +
          other_income +
          add_debt +
          fire_cost +
          meter_connect_cost +
          total_cost_late -
          reduce_debt,
      ];

      row.height = 25;
      row.alignment = { vertical: "middle" };

      rowIndex++;
    };

    // ===== SECTION 1 =====
    sectionHeader("สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา");
    data.forEach((item, i) => {
      tableRow(item);
    });
    tableRow({
      address_number: "รวมทั้งสิ้น",
      full_name: "",
      unit_used: "",
      water_bill: total(data, "water_bill"),
      equipment_maintenance_fee: total(data, "equipment_maintenance_fee"),
      common_expenses: total(data, "common_expenses"),
      waste_cost: total(data, "waste_cost"),
      cable_cost: total(data, "cable_cost"),
      other_income: total(data, "other_income"),
      add_debt: total(data, "add_debt"),
      reduce_debt: total(data, "reduce_debt"),
      fire_cost: total(data, "fire_cost"),
      meter_connect_cost: total(data, "meter_connect_cost"),
      total_cost_late: total(data, "total_cost_late"),
      total_amount: total(data, "total_amount"),
    });
    rowIndex++;

    // ===== EXPORT =====
    const buffer = await wb.xlsx.writeBuffer();

    loading(false);
    saveAs(new Blob([buffer]), `รายการค้างชำระ.xlsx`);
  };
  exportReport = async (type) => {
    const { filter_search, filter_month } = this.state;
    loading(true);
    let body = {
      page: 0,
      data_search: filter_search,
      month: filter_month ? filter_month.split("-")[1] : "",
      year: filter_month ? filter_month.split("-")[0] : "",
    };
    let result = await GET("api/admin/outstanding-payments/list", body);
    if (type === "excel") {
      this.exportExcel(result.data);
    } else {
      report_outstanding_payments(result.data);
    }
    loading(false);
  };
  render() {
    const {
      count,
      data,
      filter_search,
      filter_month,
      current_month,
      last_month,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายการค้างชำระ"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">รายการค้างชำระ</h4>
          <div className="d-flex align-items-center flex-wrap">
            {profile?.user_type !== "customer" && (
              <input
                type="text"
                className="form-control wpx-250 me-2 mb-2"
                placeholder="บ้านเลขที่, ชื่อ-สกุล"
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
            )}
            <input
              type="month"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="mm-yyyy"
              onChange={(e) => {
                this.setState({ filter_month: e.target.value });
              }}
              value={filter_month}
            />
            {/* <div className="wpx-200 me-2 mb-2">
              <DatePicker
                className="form-control"
                onChange={(e) => {
                  this.setState({ start_date: e });
                }}
                value={this.state.start_date}
              />
            </div>
            <div className="wpx-200 me-2 mb-2">
              <DatePicker
                className="form-control"
                onChange={(e) => {
                  this.setState({ end_date: e });
                }}
                value={this.state.end_date}
              />
            </div>
            <select
              className="form-control wpx-250 rounded me-2 mb-2"
              onChange={(e) => {
                this.setState({ type: e.target.value });
              }}
              value={this.state.type}
            >
              <option value="">รายการสถานะการโอน</option>
              <option value="success">Success</option>
              <option value="pending">Pending</option>
              <option value="cancel">Cancel</option>
            </select> */}
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
            {profile?.user_type !== "customer" && !profile?.customer_id && (
              <div className="d-flex ms-auto">
                <button
                  className="btn btn-primary px-4 me-2 mb-2"
                  onClick={async () => {
                    this.exportReport("excel");
                  }}
                >
                  Export Excel
                </button>
                <button
                  className="btn btn-warning px-4 me-2 mb-2"
                  onClick={async () => {
                    this.exportReport("pdf");
                  }}
                >
                  Export PDF
                </button>
              </div>
            )}
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="text-nowrap">บ้านเลขที่</th>
                    <th className="text-nowrap">ชื่อ - สกุล</th>
                    <th className="text-nowrap">วันที่จดมาตร</th>
                    <th className="text-nowrap">เลขมาตร {current_month}</th>
                    <th className="text-nowrap">เลขมาตร {last_month}</th>
                    <th className="text-end text-nowrap">จำนวนหน่วยที่ใช้</th>
                    <th className="text-end text-nowrap">ค่าน้ำประปา</th>
                    <th className="text-end text-nowrap">ค่ารักษาอุปกรณ์</th>
                    <th className="text-end text-nowrap">ค่าส่วนกลาง</th>
                    <th className="text-end text-nowrap">ค่าขยะ</th>
                    <th className="text-end text-nowrap">ค่าเคเบิล</th>
                    <th className="text-end text-nowrap">รายรับอื่นๆ</th>
                    <th className="text-end text-nowrap">เพิ่ม/ลดหนี้</th>
                    <th className="text-end text-nowrap">ค่าเบี้ยประกัน</th>
                    <th className="text-end text-nowrap">ค่าต่อมิเตอร์</th>
                    <th className="text-end text-nowrap">ค่าปรับล่าช้า</th>
                    <th className="text-end text-nowrap">รวม</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td>{item.address_number || ""}</td>
                      <td className="text-nowrap">{item.full_name || ""}</td>
                      <td>
                        {item.datetime_create
                          ? format_date(item.datetime_create)
                          : ""}
                      </td>
                      <td className="text-end">
                        {item.current_gauge_number
                          ? Number(item.current_gauge_number)
                          : "0"}
                      </td>
                      <td className="text-end">
                        {item.last_gauge_number
                          ? Number(item.last_gauge_number)
                          : "0"}
                      </td>
                      <td className="text-end">{item.unit_used || "0"}</td>
                      <td className="text-end">
                        {toFixed(item.water_bill) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.equipment_maintenance_fee) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.common_expenses) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.waste_cost) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.cable_cost) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.other_income) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.add_debt - item.reduce_debt) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.fire_cost) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.meter_connect_cost) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.total_cost_late) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(
                          item.water_bill +
                            item.equipment_maintenance_fee +
                            item.common_expenses +
                            item.waste_cost +
                            item.cable_cost +
                            item.other_income +
                            item.add_debt +
                            item.fire_cost +
                            item.meter_connect_cost +
                            item.total_cost_late -
                            item.reduce_debt,
                        ) || "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {count} รายการ</small>
            <Pagination
              count={Math.ceil(count / 10)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
